import React from 'react';
import { TitleHeader } from 'web-library';
import ActivateAccountFormRoute from '../../modules/profile/components/ActivateAccountFormRoute';

const ActivateAccount = () => (
  <>
    <TitleHeader title="Activate Account" />

    <ActivateAccountFormRoute />
  </>
);

export default ActivateAccount;
